module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.localCurrentMonth != null && _vm.localCurrentYear != null) ? _c('div', {
    staticClass: "month-navigation",
    attrs: {
      "data-testid": "navigation-mois-section"
    }
  }, [_c('button', {
    staticClass: "nav-button",
    attrs: {
      "data-testid": "navigation-mois-precedent-button"
    },
    on: {
      "click": _vm.previousMonth
    }
  }, [_c('i', {
    staticClass: "ri-arrow-left-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "months-list"
  }, _vm._l((_vm.displayedMonths), function(monthDisplay, index) {
    return _c('div', {
      key: index,
      class: ['month-item', {
        'active': monthDisplay.isCurrentMonth
      }],
      attrs: {
        "data-testid": 'navigation-annee-' + monthDisplay.year + '-month-' + monthDisplay.month + '-button'
      },
      on: {
        "click": function($event) {
          _vm.selectMonth(monthDisplay)
        }
      }
    }, [_vm._v("\n            " + _vm._s(monthDisplay.label) + "\n        ")])
  })), _vm._v(" "), _c('button', {
    staticClass: "nav-button",
    attrs: {
      "data-testid": "navigation-mois-suivant-button"
    },
    on: {
      "click": _vm.nextMonth
    }
  }, [_c('i', {
    staticClass: "ri-arrow-right-line"
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df363e1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsencesV2/calendrierMensuel/navigationMois/navigationMois.vue.html
// module id = EzNE
// module chunks = 2